module.exports = __webpack_public_path__ + "static/media/dmp-tab-lg-md.7945319c.svg";